import React from 'react';
import { motion } from 'framer-motion';
import { pricingPlans } from '../data/mockData';
import { Button } from './ui/button';
import { Check, Sparkles } from 'lucide-react';

const PricingSection = ({ onOpenContactForm }) => {
  return (
    <section id="pricing" data-testid="pricing-section" className="py-28 relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#3B82F6]/[0.04] rounded-full blur-[120px]" />
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <motion.div className="max-w-2xl mb-16" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#3B82F6]/10 border border-[#3B82F6]/20 mb-5">
            <span className="text-xs font-semibold text-[#3B82F6] uppercase tracking-wider">Pricing</span>
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-white mb-5">
            Plans Starting at <span className="text-gradient">$45</span>
          </h2>
          <p className="text-[#A1A1AA] leading-relaxed">
            Transparent trademark registration packages. No hidden fees. Expert attorneys at every tier.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {pricingPlans.map((plan, index) => (
            <motion.div key={plan.id}
              className={`rounded-2xl flex flex-col transition-all duration-300 ${
                plan.recommended
                  ? 'glass-card border-[#3B82F6]/40 relative shadow-lg shadow-[#3B82F6]/10'
                  : 'glass-card hover:border-white/[0.1]'
              }`}
              initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.05 }}>
              
              {plan.recommended && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                  <div className="btn-gradient text-white text-xs font-semibold uppercase tracking-wider px-4 py-1 rounded-full flex items-center gap-1.5">
                    <Sparkles className="w-3 h-3" /> Recommended
                  </div>
                </div>
              )}

              <div className="p-6 border-b border-white/[0.06]">
                <h3 className="font-heading text-lg font-semibold text-white mb-3">{plan.name}</h3>
                <div className="flex items-baseline gap-1">
                  <span className="font-heading text-4xl font-semibold text-gradient">{plan.price}</span>
                </div>
                <p className="text-xs text-[#71717A] mt-1">{plan.federal}</p>
              </div>

              <div className="p-6 flex-1">
                <ul className="space-y-2.5">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-2.5">
                      <Check className="w-4 h-4 text-[#3B82F6] mt-0.5 shrink-0" />
                      <span className="text-sm text-[#A1A1AA]">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="p-6 pt-0">
                <p className="text-xs text-[#52525B] mb-3">{plan.note}</p>
                <Button data-testid={`pricing-btn-${plan.id}`} onClick={onOpenContactForm}
                  className={`w-full font-semibold text-sm rounded-lg transition-all ${
                    plan.recommended
                      ? 'btn-gradient text-white border-0'
                      : 'bg-white/[0.05] text-white hover:bg-white/[0.1] border border-white/[0.08]'
                  }`}>
                  {plan.buttonText}
                </Button>
              </div>
            </motion.div>
          ))}
        </div>

        <p className="text-sm text-[#52525B] mt-8">
          <strong className="text-[#A1A1AA]">Note:</strong> All packages exclude USPTO federal filing fees ($250-$350 per class).
        </p>
      </div>
    </section>
  );
};

export default PricingSection;
